import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { VideoRecordingIcon } from "../VideoRecordingIcon";

export function SkillsAssessmentAlreadyCompletedFromOnboardingStep() {
  return (
    <Stack spacing={4}>
      <Stack alignItems="center">
        <VideoRecordingIcon sx={{ fontSize: "64px" }} />
      </Stack>

      <Text sx={{ lineHeight: "24px" }}>
        You&apos;ve already completed the video assessment! Continue to add your payment
        information.
      </Text>
    </Stack>
  );
}
